"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  presentationProductDetailDefaultTranslations: true,
  presentationProductDetailTranslationsNamespace: true
};
Object.defineProperty(exports, "presentationProductDetailDefaultTranslations", {
  enumerable: true,
  get: function () {
    return _constants.defaultTranslations;
  }
});
Object.defineProperty(exports, "presentationProductDetailTranslationsNamespace", {
  enumerable: true,
  get: function () {
    return _constants.translationsNamespace;
  }
});
var _components = require("./components");
Object.keys(_components).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _components[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _components[key];
    }
  });
});
var _constants = require("./constants");
//# sourceMappingURL=index.js.map